import React from 'react';
import { Result, Button } from 'antd';

const Error401M = () => (
  <Result
    status="403"
    title="401"
    subTitle="對不起，您的權限不足，無法訪問此頁面。"
  />
);

export default Error401M;
